.form {
	display: flex;
	flex-direction: column;
	gap: var(--size-4);
	width: 100%;
}

.steps {
	list-style: none;
	counter-reset: step;
	padding: 0;
	margin: 0;
	display: flex;
	flex-direction: column;
	gap: var(--size-5);
}

.steps > li {
	counter-increment: step;
	display: grid;
	grid-template-columns: auto 1fr;
	column-gap: var(--size-4);
	row-gap: var(--size-3);
	align-items: start;
}

.steps > li::before {
	content: counter(step);
	grid-row: 1 / span 2;
	width: var(--size-7);
	height: var(--size-7);
	border-radius: 50%;
	background-color: var(--color-surface);
	color: var(--color-text);
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 600;
	font-size: var(--text-caption);
}

.scan {
	display: grid;
	grid-template-columns: auto 1fr;
	gap: var(--size-4);
	align-items: center;
	min-width: 0;
}

.qr {
	display: flex;
	justify-content: center;
	padding: var(--size-2);
	background-color: var(--color-surface-elevated);
	border: var(--size-border) solid var(--color-border);
	border-radius: var(--radius-lg);

	> svg {
		width: 8rem;
		height: 8rem;
	}
}

.inputs {
	display: flex;
	flex-direction: column;
	gap: var(--size-4);
	min-width: 0;
}

.manual {
	display: flex;
	flex-direction: column;
	gap: var(--size-2);
	min-width: 0;

	> .blurb {
		color: var(--color-text-subtle);
		font-size: var(--text-caption);
		margin: 0;
	}
}

.codes {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: var(--size-2) var(--size-6);
	padding: var(--size-3) var(--size-4);
	background-color: var(--color-surface-elevated);
	border: var(--size-border) solid var(--color-border);
	border-radius: var(--radius-lg);
	list-style: none;
	font-family: var(--font-mono);
	margin: var(--size-4) 0;
}

.confirm {
	margin: var(--size-4) 0;
	display: flex;
	align-items: center;
	gap: var(--size-4);
}

.actions {
	display: flex;
	gap: var(--size-3);
	justify-content: flex-end;
}

.error {
	color: var(--color-error-text);
	font-size: var(--text-caption);

	&:empty {
		display: none;
	}
}
